// extracted by mini-css-extract-plugin
export var deleteIcon = "_nm-5";
export var deleteOption = "_nm-3";
export var divider = "_nm-2";
export var downloadIcon = "_nm-4";
export var drawer = "_nm-0";
export var drawerFooter = "_nm-6";
export var drawerOpen = "_nm-1";
export var highlighted = "_nm-7";
export var lighterHighlight = "_nm-8";